const styles = (theme) => ({
  topContainer: {
    backgroundColor: theme.palette.background.paper,
  },
  topBar: {
    padding: 20,
    marginTop: 10,
  },
  smallCell: { padding: "0 4px", textAlign: "center" },
  content: {
    "&:first-child": {
      marginTop: 15,
      marginBottom: 60,
    },
    paper: {
      margin: "0 auto",
      padding: "10px 5px",
    },
  },
  textField: {
    width: "90%",
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  addPlayerbutton: {
    position: "fixed",
    bottom: 10,
    right: 10,
  },
});

export default styles;
